<template>
  <main class="relative max-h-screen">
    <img src="../../assets/images/login-Bg.svg" alt="" class="w-full h-screen object-cover">
    <div class="absolute mobile:w-full desktop:w-1/3 top-0 right-0">
      <div
        class="mobile:px-8 tablet:px-32 laptop:px-48 desktop:px-16 largeDesktop:px-28 h-screen flex flex-col items-center justify-center bg-opacity-80 bg-black-100">
        <!-- same icon as the Android fyxify PRO app (ic_launcher-playstore) -->
        <img src="../../assets/images/fyxify-logo-circle.svg"
          class="w-24 h-24 md:w-28 md:h-28 largeDesktop:w-40 largeDesktop:h-40 object-cover rounded-[22%] shadow-lg" alt="fyxify PRO Logo">
        <h4
          class="text-center font-roboto text-2xl tablet:text-3xl largeDesktop:text-4xl font-medium mobile:my-3 tablet:my-5 md:my-4 largeDesktop:my-10 text-white">
          Welcome to fyxify PRO!
        </h4>
        <div class="grid w-full mobile:gap-2 md:gap-4 largeDesktop:gap-5">
          <div class="form-group">
            <label for="email" class="text-base font-roboto mb-1 text-white">Email:</label>
            <inputComponent ref="emailRef" v-model="email" name="email" required :regex="$constants.EMAIL_REGEX"
              error-message="Please enter a valid email address" placeholder="Enter Email"
              custom-class="!text-[16px] !py-[8px] largeDesktop:!py-[12px]" />
            <!-- <input v-model="email" type="email" class="form-control focus:border-gray-400" placeholder="Enter email"> -->
          </div>
          <div class="form-group">
            <label for="password" class="text-base font-roboto  mb-1 text-white">Password:</label>
            <div class="relative">
              <inputComponent ref="passwordRef" v-model="password" name="password" type="password" required
                placeholder="Enter Password" custom-class="!text-[16px] !py-[8px] largeDesktop:!py-[12px]" />
            </div>
          </div>
        </div>
        <div
          class="grid mobile:gap-3 tablet:gap-4 md:gap-4 largeDesktop:gap-8 mobile:my-4 tablet:my-5 md:my-7 largeDesktop:my-12 w-full">
          <button
            class="px-10 largeDesktop:px-16 py-1.5 largeDesktop:py-2 rounded-full uppercase font-roboto desktop:text-lg largeDesktop:text-xl w-max m-auto text-white bg-[#FE5000] cursor-pointer disabled:!text-gray-500 disabled:!bg-none disabled:bg-gray-300"
            type="submit" :disabled="issubmitDisabled()" @click="loginClicked()">
            Login
          </button>
          <a class="text-center no-underline text-base cursor-pointer text-white" @click="forgetPassword">Forgot
            password?</a>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {
  mapActions,
  mapGetters
} from "vuex";
import inputComponent from '../../components/partialComponent/inputComponent.vue';
import {
  getBrowserFingerprint
} from '@/helpers/fingerprint';
export default {
  components: {
    inputComponent
  },
  data() {
    return {
      email: '',
      password: '',
      passwordVisible: false,
      showPasswordIcon: require("../../assets/images/show-password-icon.png"),
      hidePasswordIcon: require("../../assets/images/hide-password-icon.png"),
      fingerprint: '',
    };
  },

  watch: {
    userObject: function () {
      if (this.userObject != 'undefined') {
        if (this.userObject.user.email_verification == '0') {
          localStorage.setItem('registerFormData', JSON.stringify({
            email: this.email.trim()
          }));
          this.$router.push({
            name: 'verification'
          })
        } else {
          localStorage.removeItem('registerFormData')
          localStorage.setItem('user', JSON.stringify(this.userObject))
          localStorage.setItem('isSilentLogin', false)
          sessionStorage.removeItem('dashboard_selected_date') // fresh login: dashboard opens on today
          this.$router.push({
            path: '/dashboard'
          })
        }
      }

    },
  },

  computed: {
    ...mapGetters(["userObject"]),
    passwordFieldType() {
      return this.passwordVisible ? "text" : "password";
    },
  },

  async created() {
    this.fingerprint = await getBrowserFingerprint();
  },

  mounted() {
  },

  methods: {
    ...mapActions(["proLogin"]),

    issubmitDisabled() {

      if (this.email.length <= 0 || this.password.length <= 0) {
        return true
      }
      else if (!this.validateEmail()) {
        return true
      } else {
        return false
      }
    },

    validateEmail() {
      const emailPattern = this.$constants.EMAIL_REGEX;
      if (!emailPattern.test(this.email.trim())) {
        return false
      } else {
        return true
      }
    },

    onProLogin() {
      this.proLogin({
        email: this.email.trim(),
        password: this.password,
        device_type: 'web',
        device_id: this.fingerprint,
        user_type: 'technician'

      });
    },
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;
    },

    loginClicked() {
      this.onProLogin()
    },

    forgetPassword() {
      this.$router.push({
        name: 'forgetPassword'
      })
    }
  },

};
</script>